<template>
    <button
        v-on="$listeners"
        :class="{ btn: true, 'is-loading': isLoading }"
        :disabled="disabled || isLoading"
    >
        <SpinnerBars
            v-if="isLoading"
        />
        <slot v-else />
    </button>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('CustomButton', {
        props: {
            isLoading: {
                type: Boolean,
                required: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            }
        }
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/Button.vue